import React, { useState, useMemo, useContext } from "react";
import { useNavigate } from "react-router-dom";
import FareRule from "./FareRule";
import { AuthContext } from "../../Routes/AuthProvider"


/* ================= FARE UTILS ================= */
const calcFare = (fare = {}) => {
  return (
    Number(fare.totalBaseFare || 0) +
    Number(fare.totalFuelSurcharge || 0) +
    Number(fare.totalTax || 0)
  );
};

const IntRoundTrip = ({
  data,
  onwardFlights = [],
  returnFlights = [],
  loading,
  error,
  totalPax,
  requestBody,
  filteredOnwardFlights,
  filteredReturnFlights,
  handleBookNow,
}) => {
  const navigate = useNavigate();

  /* ================= STATES ================= */
  const [sortType, setSortType] = useState("DEPARTURE");
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [selectedFare, setSelectedFare] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("info");
   const { name, userName, roles, corporateId } = useContext(AuthContext);

  const [selectedFareMap, setSelectedFareMap] = useState({});
  const [fareRuleIndex, setFareRuleIndex] = useState(null);

  const formatINR = (value) => {
    return Number(value || 0).toLocaleString("en-IN");
  };
  /* ================= FORMATTERS ================= */
  const formatTime = (dateString) =>
    dateString
      ? new Date(dateString).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
      : "—";

  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };
  const [loadFareRule, setLoadFareRule] = useState(false);
  const handleFinalBook = async (flight, index) => {
    setLoadingFlightIndex(index);
    await handleBookNow(flight, index);
    setLoadingFlightIndex(null);
  };

  /* ================= VIEW MORE FARE ================= */
  const handleViewMoreFare = (flight) => {
    if (!flight) return;
    console.log("flight", flight);
    setSelectedFlight({
      ...flight
    });

    setSelectedFare(null);
    setSelectedFareIndex(null);

    setTimeout(() => {
      const el = document.getElementById("ViewMoreFare");
      if (el && window.bootstrap) {
        window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
      }
    }, 50);
  };

  /* ================= RENDER ================= */


  // Show loader
  if (loading) {
    return (
      <p className="text-center load">
        <span className="loader"></span>
      </p>
    );
  }

  // No flights
  if (!loading && returnFlights.length === 0) {
    return (
      <p className="text-center">
        No International Round-Trip Flights Found
      </p>
    );
  }

  return (
    <>
      {/* ================= SORT BAR ================= */}
      <div className="row ruslt_sort mb-3">
        <div className="col-md-4">
          <div className="d_flex_dxb">
            <span className="plac_nam">
              {data.departureAirportCode} → {data.arrivalAirportCode}
            </span>
            {/* <span className="plac_nam_date">{data.onwardDate}</span> */}
            <span style={{ color: "red" }}> {formatDateForDisplay(data.onwardDate)}</span>

          </div>
          <div className="d_flex_dxb">
            <span className="plac_nam">
              {data.arrivalAirportCode} → {data.departureAirportCode}
            </span>
            {/* <span className="plac_nam_date">{data.returnDate}</span> */}
            <span style={{ color: "red" }}> {formatDateForDisplay(data.returnDate)}</span>
          </div>
        </div>

        <div className="col-md-6 text-left">

          <div className="d-flex-reco intRound">
            <div
              className={`fastest ${sortType === "CHEAPEST" ? "active" : ""}`}
              onClick={() => setSortType("CHEAPEST")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setSortType("CHEAPEST")}
            >
              <img src="/assets/images/rupee.png" alt="Cheapest" />
              <h4>Cheapest</h4>
            </div>

            <div
              className={`fastest ${sortType === "FASTEST" ? "active" : ""}`}
              onClick={() => setSortType("FASTEST")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setSortType("FASTEST")}
            >
              <img src="/assets/images/speed.png" alt="Fastest" />
              <h4>Fastest</h4>
            </div>

            <div
              className={`fastest ${sortType === "NONSTOP" ? "active" : ""}`}
              onClick={() => setSortType("NONSTOP")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setSortType("NONSTOP")}
            >
              <img src="/assets/images/flight-blue.png" alt="Non Stop" />
              <h4>Non Stop</h4>
            </div>

            <div
              className={`fastest ${sortType === "DEPARTURE" ? "active" : ""}`}
              onClick={() => setSortType("DEPARTURE")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setSortType("DEPARTURE")}
            >
              <img src="/assets/images/flight-blue.png" alt="Departure" />
              <h4>Departure</h4>
            </div>
          </div>

        </div>

        <div className="col-md-2 text-center pt-5">
          <button
            className="modify_btn_sr"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result →
          </button>
        </div>
      </div>


      {/* ================= LIST ================= */}
      {returnFlights.map((item, idx) => {
        const onwardSegments = item.segments?.filter(x => x.flightCount === 1) || [];
        const returnSegments = item.segments?.filter(x => x.flightCount === 2) || [];

        const onwardFirst = onwardSegments[0];
        const onwardLast = onwardSegments[onwardSegments.length - 1];

        const returnFirst = returnSegments[0];
        const returnLast = returnSegments[returnSegments.length - 1];

        return (
          <div className="result_repeat mb-3" key={idx}>
            <div className="row">
              {/* ---------- LEFT SIDE (FLIGHT DETAILS) ---------- */}
              <div className="col-md-9">
                {/* ----- ONWARD ----- */}
                <div className="row oneWay_flight_1">
                  <p className="mode_trvel">
                    <span>
                      <i className="fa fa-plane"></i> Departure
                    </span>
                  </p>

                  <div className="col-md-4 col-lg-4">
                    <div className="row">
                      <div className="col-md-4">
                        <img
                          src={`/assets/images/Flight_Images/${onwardFirst?.airLineCode}.gif`}
                          width="30"
                          alt=""
                        />
                      </div>
                      <div className="col-md-8">
                        <span>
                          {onwardSegments?.map((seg, i) => (
                            <span key={i}>
                              {seg.airLineCode}-{seg.flightNumber}
                              {i < onwardSegments.length - 1 && "/"}
                            </span>
                          ))}
                        </span>
                        <div>{onwardFirst.airLineName}</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-8 border-left-right">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="timer">
                          <h4>{onwardFirst.departDateTime?.slice(11, 16)}</h4>
                          <p>{onwardFirst.departAirportCode}</p>
                        </div>
                      </div>
                    

                      <div className="col-md-3">
                        <div className="deruation">
                          <p>{item.totalDuration}</p>

                          <div className="bordr_top">
                            <i className="fa fa-plane"></i>
                          </div>
                          <p className="stops">
                            {onwardSegments.length - 1}{" "}
                            {(onwardSegments.length - 1) === 1 ? "stop" : "stops"}
                          </p>
                        </div>
                      </div>

                      <div className="col-md-4 offset-1">
                        <div className="timer">
                          <h4>{onwardLast.arrivalDateTime?.slice(11, 16)}</h4>
                          <p>{onwardLast.arrivalAirportCode}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ----- RETURN ----- */}
                <div className="row oneWay_flight_2">
                  <p className="mode_trvel">
                    <span>
                      <i className="fa fa-plane"></i> Return
                    </span>
                  </p>

                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-4">
                        <img
                          src={`/assets/images/Flight_Images/${returnFirst?.airLineCode}.gif`}
                          width="30"
                          alt=""
                        />
                      </div>
                      <div className="col-md-8">
                        <span>
                          {returnSegments?.map((seg, i) => (
                            <span key={i}>
                              {seg.airLineCode}-{seg.flightNumber}
                              {i < returnSegments.length - 1 && "/"}
                            </span>
                          ))}
                        </span>
                        <div>{returnFirst.airLineName}</div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-8 border-left-right">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="timer">
                          <h4>{returnFirst?.departDateTime?.slice(11, 16)}</h4>
                          <p>{returnFirst?.departAirportCode}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="deruation">
                          <p>{item.totalDurationReturn}</p>
                          <div className="bordr_top">
                            <i className="fa fa-plane"></i>
                          </div>
                          <p className="stops">
                            {returnSegments.length - 1}{" "}
                            {(returnSegments.length - 1) === 1 ? "stop" : "stops"}
                          </p>
                        </div>
                      </div>

                      <div className="col-md-4 offset-1">
                        <div className="timer">
                          <h4>{returnLast.arrivalDateTime?.slice(11, 16)}</h4>
                          <p>{returnLast.arrivalAirportCode}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ----- Services / Refundability ----- */}
                <div className="col-md-12">
                  <ul className="list_service">

                    {/* Equipment + Seats */}
                    <li>
                      <div className="d-flex">
                        <div className="equipmentType">
                          <i className="fa-solid fa-fan"></i>
                          <span>{onwardFirst?.equipmentType || "-"}</span>
                        </div>

                        <div className="equipmentType">
                          <img
                            className="seats"
                            src="/assets/images/seat.png"
                            alt="seat"
                          />
                          <span>{onwardFirst?.availableSeats ?? "-"} Seats</span>
                        </div>
                      </div>
                    </li>

                    {/* Refundable */}
                    <li className="refundable">
                      {item?.fares?.[0]?.isRefundable ? (
                        <span style={{ color: "green", fontWeight: 500 }}>Refundable</span>
                      ) : (
                        <span style={{ color: "red", fontWeight: 500 }}>Non-Refundable</span>
                      )}
                    </li>
                     {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                          <li className="view_on">
                            <p class="policyStatus text-success">{item?.supSource}</p>
                          </li>
                       )} 

                    {/* Flight Details */}
                    <li className="view_on">
                      <a
                        className="flight_details"
                        role="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#FlightDetails"
                        onClick={() =>
                          setSelectedFlight({
                            ...item,
                            onwardSegments,
                            returnSegments,
                            selectedFareIndex: 0
                          })
                          //</li>console.log("setSelectedFlight", returnSegments)
                        }
                      >
                        <i className="fa fa-plane"></i> Flight Details
                      </a>
                    </li>


                  </ul>
                </div>

              </div>

              {/* ---------- RIGHT SIDE (PRICE + BUTTONS) ---------- */}

              <div className="col-md-3">
                <div className="price_int">
                  <p className="type_frs">
                    {/* {
                      selectedFareMap[item?.fares?.[0]?.fareType] ??
                      "Standard Fare"
                    } */}
                    {
                      item?.fares?.[0]?.fareType ??
                      "Standard Fare"
                    }
                  </p>
                   <div className="cos_int_flight">
                    <i className="fa fa-inr"></i>{" "}
                    {formatINR(item?.fares?.[0]?.totalFare)}
                  </div>
                  <p
                    className={`policyStatus ${item?.fares?.[0]?.policyStatus === "WithinPolicy"
                        ? "text-success"
                        : item?.fares?.[0]?.policyStatus === "OutOfPolicy"
                          ? "text-danger"
                          : ""
                      }`}
                  >
                    {item?.fares?.[0]?.policyStatus && (
                      <img
                        src={
                          item?.fares?.[0]?.policyStatus === "WithinPolicy"
                            ? "/assets/images/approved.png"
                            : item?.fares?.[0]?.policyStatus === "OutOfPolicy"
                              ? "/assets/images/cancelled.png"
                              : ""
                        }
                        alt="status"
                        style={{ marginRight: "6px" }}
                      />
                    )}

                    {item?.fares?.[0]?.policyStatus}
                  </p>

                 

                  <button
                    className="view_more"
                    onClick={() => handleViewMoreFare(item)}
                  >
                    View More Fare
                  </button>

                  <button
                    className="book_now_fly"
                    onClick={() => {
                      const selectedFare = item.fares?.[0];
                      const updatedFlight = {
                        ...item,
                        selectedFare,
                        selectedFareIndex: 0
                      };
                      console.log("BOOK:", selectedFare?.fareUniqueKey);
                      handleBookNow(updatedFlight, 0);
                    }}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}


      {/* ================= OFFCANVAS More Fare ================= */}
      <div
        className="offcanvas offcanvas-end"
        id="ViewMoreFare"
        tabIndex="-1"
      >
        <div className="offcanvas-header">
          <h5>More Fare Options</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode}) →{" "}
                      {
                        (() => {
                          const onwardSegments = selectedFlight?.segments?.filter(x => x.flightCount === 1) || [];
                          const lastSeg = onwardSegments[onwardSegments.length - 1];

                          return lastSeg
                            ? `${lastSeg.arrivalCityName} (${lastSeg.arrivalAirportCode})`
                            : "";
                        })()
                      }
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>
                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{(() => {
                      const onwardSegments = selectedFlight?.segments?.filter(x => x.flightCount === 1) || [];
                      const lastSeg = onwardSegments.at(-1);
                      return lastSeg ? formatTime(lastSeg.arrivalDateTime) : "";
                    })()}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare.fareType || "Standard Fare"}</h5>
                      <p
                        className={`policyStatus text-en ${fare?.policyStatus === "WithinPolicy"
                          ? "text-success"
                          : fare?.policyStatus === "OutOfPolicy"
                            ? "text-danger"
                            : ""
                          }`}
                      >
                        {fare?.policyStatus && (
                          <img
                            src={
                              fare.policyStatus === "WithinPolicy"
                                ? "/assets/images/approved.png"
                                : fare.policyStatus === "OutOfPolicy"
                                  ? "/assets/images/cancelled.png"
                                  : ""
                            }
                            alt="status"
                            style={{ marginRight: "6px" }}
                          />
                        )}

                        {fare.policyStatus}
                      </p>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {formatINR(fare.totalFare)}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>



                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <p
                          className="faReRule"
                          data-bs-toggle="modal"
                          data-bs-target="#FareRuleModal"
                          onClick={() => {
                            if (!selectedFlight?.itemNo) return;
                            setLoadFareRule(true);
                            setFareRuleIndex(index);
                          }}
                        >
                          Fare Rule
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare({
                              ...fare,
                              totalFare: fare.roundTripFare,
                            });

                            setSelectedFareIndex(index);

                            // ✅ ADD THIS (IMPORTANT)
                            setSelectedFareMap(prev => ({
                              ...prev,
                              [selectedFlight.itemNo]: {
                                ...fare,
                                selectedIndex: index
                              }
                            }));
                            setSelectedFareIndex(index);
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}

        </div>
        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total <span style={{ color: 'red' }}>({selectedFare.fareType || ""})</span> </p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {formatINR(
                selectedFlight?.fares?.[selectedFareIndex]?.totalFare ?? 0
              )}
            </h1>

            <button
              className="btn btn-primary"
              onClick={() => {

                const selectedFareData =
                  selectedFlight?.fares?.[selectedFareIndex ?? 0];

                const updatedFlight = {
                  ...selectedFlight,
                  selectedFare: selectedFareData,
                  selectedFareIndex: selectedFareIndex ?? 0
                };

                console.log("INT FINAL:", {
                  fareKey: updatedFlight?.selectedFare?.fareUniqueKey,
                  index: selectedFareIndex
                });

                handleBookNow(updatedFlight, selectedFareIndex);
              }}
              disabled={loadingFlightIndex === selectedFareIndex}
              data-bs-dismiss="offcanvas"
            >
              Book Now
            </button>

          </div>
        )}

      </div>

      {/* ===================== Offcanvas for Flight Details ================ */}


      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setActiveTab("info");
              setLoadFareRule(false);
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              {/* Tabs */}

              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                {/* Flight Info */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                    onClick={() => setActiveTab("info")}
                  >
                    Flight Information
                  </a>
                </li>

                {/* Fare Rules */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "fare" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                    onClick={() => {
                      setActiveTab("fare");

                      if (!selectedFlight?.itemNo) return;
                      setLoadFareRule(true);
                    }}
                  >
                    Fare Rules & Cancellation Change Rule
                  </a>
                </li>

                {/* Baggage */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "baggage" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                    onClick={() => setActiveTab("baggage")}
                  >
                    Baggage Information
                  </a>
                </li>



              </ul>

              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="kt_tab_pane_4" role="tabpanel">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="int_don_flight">
                        {selectedFlight.onwardSegments?.length > 0 && (
                          <div> {/* Wrap all onward segments in a single parent div */}
                            {/* ----- HEADER ----- */}
                            <p className="mode_trvel">
                              <span><i className="fa fa-plane"></i> Departure </span>
                            </p>

                            {/* ----- DEPARTURE INFO ----- */}
                            <div className="d-flex-v">
                              <div className="d-flex-v-f">
                                <h4>{formatTime(selectedFlight.segments[0]?.departDateTime)}</h4>
                              </div>
                              <div className="d-flex-v-m"><span className="zero"></span></div>
                              <div className="d-flex-v-l">
                                <h4>{selectedFlight.origin}</h4>
                                <p>
                                  {selectedFlight.segments[0]?.departAirportName}
                                  {selectedFlight.segments[0]?.departTerminal
                                    ? `,  ${selectedFlight.segments[0]?.departTerminal}`
                                    : ""}
                                </p>
                              </div>
                            </div>

                            {/* ----- SEGMENTS ----- */}
                            <div className="d-flex-v time_to_frm">
                              <div className="d-flex-v-l m-autto">
                                {selectedFlight.onwardSegments.map((seg, index, arr) => {
                                  const departDate = new Date(seg.departDateTime);
                                  const arrivalDate = new Date(seg.arrivalDateTime);

                                  const getDurationBetween = (fromTime, toTime) => {
                                    const diffMs = new Date(toTime) - new Date(fromTime);
                                    if (diffMs <= 0) return "";
                                    const minutes = Math.floor(diffMs / 60000);
                                    const hrs = Math.floor(minutes / 60);
                                    const mins = minutes % 60;
                                    return `${hrs > 0 ? hrs + "h " : ""}${mins}m`;
                                  };

                                  const departTime = departDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                  const arrivalTime = arrivalDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

                                  const isLast = index === arr.length - 1;
                                  const nextSeg = arr[index + 1];
                                  const layoverDuration = nextSeg && getDurationBetween(seg.arrivalDateTime, nextSeg.departDateTime);

                                  return (
                                    <div key={index}>
                                      {/* SEGMENT INFO */}
                                      <div className="d-flex mb-3 align-items-center">
                                        <div className="d-flex-v-f m-autto me-3">
                                          <h6>{departDate.toDateString()}</h6>
                                          <p className="mb-0">{departTime} ➜ {arrivalTime}</p>
                                        </div>

                                        <div className="d-flex-v-m fhty_rg">
                                          <i className="fa fa-plane flights"></i>
                                        </div>

                                        <div className="d-flex">
                                          <div className="img_flt">
                                            <img
                                              className="flight_i"
                                              src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                              alt={seg.airLineName}
                                            />
                                          </div>
                                          <div className="flt_name ms-2">
                                            {seg.airLineName} – {seg.airLineCode}-{seg.flightNumber}
                                          </div>
                                        </div>
                                      </div>

                                      {/* LAYOVER INFO */}
                                      {!isLast && layoverDuration && (
                                        <div className="layover-info">
                                          <p className="mb-0">
                                            <strong>Stop:</strong> {seg.arrivalCity || seg.arrivalAirportName || seg.destination}
                                          </p>
                                          <h4 className="text-red">Layover: {layoverDuration}</h4>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>

                            {/* ----- ARRIVAL INFO ----- */}
                            <div className="d-flex-v">
                              {(() => {
                                const segments = selectedFlight.onwardSegments || [];
                                const lastSeg = segments[segments.length - 1] || {};

                                return (
                                  <>
                                    <div className="d-flex-v-f">
                                      <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                                    </div>

                                    <div className="d-flex-v-m">
                                      <span className="zero"></span>
                                    </div>

                                    <div className="d-flex-v-l">
                                      <h4>{selectedFlight.destination || lastSeg.destination}</h4>
                                      <p>
                                        {lastSeg.arrivalAirportName}
                                        {lastSeg.arrivalTerminal ? `,  ${lastSeg.arrivalTerminal}` : ""}
                                      </p>
                                    </div>
                                  </>
                                );
                              })()}
                            </div>
                          </div> // end wrapper
                        )}
                      </div>

                    </div>
                    <div className="col-md-6">

                      {selectedFlight.returnSegments?.length > 0 && (
                        <div className="int_don_flight">
                          {/* ----- RETURN HEADER ----- */}
                          <p className="mode_trvel">
                            <span><i className="fa fa-plane"></i> Return </span>
                          </p>

                          {/* ----- DEPARTURE INFO ----- */}
                          <div className="d-flex-v">
                            <div className="d-flex-v-f">
                              <h4>{formatTime(selectedFlight.returnSegments[0]?.departDateTime)}</h4>
                            </div>
                            <div className="d-flex-v-m"><span className="zero"></span></div>
                            <div className="d-flex-v-l">
                              <h4>{selectedFlight.destination}</h4>
                              <p>
                                {selectedFlight.returnSegments[0]?.departAirportName}
                                {selectedFlight.returnSegments[0]?.departTerminal
                                  ? `,  ${selectedFlight.returnSegments[0]?.departTerminal}`
                                  : ""}
                              </p>
                            </div>
                          </div>

                          {/* ----- SEGMENTS ----- */}
                          <div className="d-flex-v time_to_frm">
                            <div className="d-flex-v-l m-autto">
                              {selectedFlight.returnSegments.map((seg, index, arr) => {
                                const departDate = new Date(seg.departDateTime);
                                const arrivalDate = new Date(seg.arrivalDateTime);

                                const getDurationBetween = (fromTime, toTime) => {
                                  const diffMs = new Date(toTime) - new Date(fromTime);
                                  if (diffMs <= 0) return "";
                                  const minutes = Math.floor(diffMs / 60000);
                                  const hrs = Math.floor(minutes / 60);
                                  const mins = minutes % 60;
                                  return `${hrs > 0 ? hrs + "h " : ""}${mins}m`;
                                };

                                const departTime = departDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
                                const arrivalTime = arrivalDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

                                const isLast = index === arr.length - 1;
                                const nextSeg = arr[index + 1];
                                const layoverDuration = nextSeg && getDurationBetween(seg.arrivalDateTime, nextSeg.departDateTime);

                                return (
                                  <div key={index}>
                                    {/* SEGMENT */}
                                    <div className="d-flex mb-3 align-items-center">
                                      {/* DATE + TIME */}
                                      <div className="d-flex-v-f m-autto me-3">
                                        <h6>{departDate.toDateString()}</h6>
                                        <p className="mb-0">{departTime} ➜ {arrivalTime}</p>
                                      </div>

                                      <div className="d-flex-v-m fhty_rg">
                                        <i className="fa fa-plane flights"></i>
                                      </div>

                                      {/* AIRLINE */}
                                      <div className="d-flex">
                                        <div className="img_flt">
                                          <img
                                            className="flight_i"
                                            src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                            alt={seg.airLineName}
                                          />
                                        </div>
                                        <div className="flt_name ms-2">
                                          {seg.airLineName} – {seg.airLineCode}-{seg.flightNumber}
                                        </div>
                                      </div>
                                    </div>

                                    {/* STOP / LAYOVER INFO */}
                                    {!isLast && layoverDuration && (
                                      <div className="layover-info">
                                        <p className="mb-0">
                                          <strong>Stop:</strong> {seg.arrivalCity || seg.arrivalAirportName || seg.destination}
                                        </p>
                                        <h4 className="text-red">Layover: {layoverDuration}</h4>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          {/* ----- ARRIVAL INFO ----- */}
                          <div className="d-flex-v">
                            {(() => {
                              const segments = selectedFlight.returnSegments || [];
                              const lastSeg = segments[segments.length - 1] || {};

                              return (
                                <>
                                  <div className="d-flex-v-f">
                                    <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                                  </div>

                                  <div className="d-flex-v-m">
                                    <span className="zero"></span>
                                  </div>

                                  <div className="d-flex-v-l">
                                    <h4>{selectedFlight.origin || lastSeg.destination}</h4>
                                    <p>
                                      {lastSeg.arrivalAirportName}
                                      {lastSeg.arrivalTerminal ? `,  ${lastSeg.arrivalTerminal}` : ""}
                                    </p>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      )}

                    </div>



                  </div>
                </div>
                <div className="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div className="row">
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={0}
                      />
                    </div>

                  </div>
                </div>
                <div className="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name"
                            src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p className="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p className="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div className="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ================= TOTAL ================= */}
              <div className="total_amount">
                <p className="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight?.fares?.[0]?.totalFare ?? 0).toLocaleString("en-IN")}
                </h1>

                <button
                  className="btn btn-primary"
                  onClick={() => handleFinalBook(selectedFlight, selectedFareIndex ?? 0)}
                  disabled={loadingFlightIndex && loadingFlightIndex === selectedFareIndex}
                >
                  {loadingFlightIndex && loadingFlightIndex === selectedFareIndex
                    ? "Checking Price..."
                    : "Book Now"}
                </button>

              </div>

            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

      </div>

      {/* Fare Rule For Perticular Fare */}

      <div className="modal fade" id="FareRuleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Fare Rule</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={() => setLoadFareRule(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {selectedFlight && loadFareRule && fareRuleIndex !== null && (
                  <>
                    <div className="col-md-12">
                      <FareRule
                        key={`${selectedFlight?.itemNo}_${loadFareRule}_${Date.now()}`}
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={fareRuleIndex}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default IntRoundTrip;
